// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import {
  MobileListItem,
  MobileListWrapper,
} from '../../utils/Styles/MobileListItem';
import NoImage from '../../../NoImage.png';
import { getConfig } from '../../../config';

const StyledImgWrapper = styled.div`
  flex: 0 0 auto;
`;

const StyledContentWrapper = styled.div`
  margin-left: 20px;
  flex: 1 1 auto;
`;

const config = getConfig();

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivitiesListMobile = ({ activities, handleOnClick }) => {
  return (
    <MobileListWrapper>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {activities.map(activity => (
        <MobileListItem
          key={activity.id}
          href={`${config.batchAdminURL}/experiences/${activity.id}`}
          onClick={handleOnClick}
        >
          <StyledImgWrapper>
            <img
              src={
                activity.pictures?.length > 0
                  ? `${activity.pictures[0].url}?tr=w-600`
                  : NoImage
              }
              style={{ width: '100px', height: 'auto' }}
              alt='...'
              className='img-thumbnail'
            />
          </StyledImgWrapper>
          <StyledContentWrapper>
            <h5 className='title' style={{ marginRight: 0 }}>
              {activity.title}
            </h5>
            <div className='item'>{activity.city}</div>
          </StyledContentWrapper>
        </MobileListItem>
      ))}
    </MobileListWrapper>
  );
};

export default ActivitiesListMobile;
